export const configInformationZoneDh = {
  "data": {
    "Type": "GeoJSON",
    "url": "pri/data/Aerial/information.json",
    "update_interval": 0,
    "retain": true,
    "cache": true,
  }
}

export const configInformationZoneLayer = {
  "Name": "InformationZone",
  "Renderer": "GeoJSONExt",
  "Attributes": {
    "features": {
      "Point": [{
        "style": {
          "default": [
            {
              "type": "circle",
              "line_color": "#7f00ff",
              "fill_color": "rgba(0,0,0,0)",
              "line_width": 2,
              "line_dash": [15, 4],
            },
            {
              "type": "point",
              "line_color": "#7f00ff",
              "fill_color": "rgba(0,0,0,0)",
              "line_width": 2,
              "point_size": 10,
            },
          ]
        }
      }],
      "Polygon": [{
        "style": {
          "default": {
            "line_color": "#7f00ff",
            "fill_color": "rgba(0,0,0,0)",
            "line_width": 2,
            "line_dash": [15, 4],
          }
        }
      }]
    }
  }
}